export default __webpack_public_path__ + "static/media/vivoauth.cc66ca68.svg";